import { PlacementTypeProduct } from './PlacementTypeProduct';

export interface FaucetProduct extends PlacementTypeProduct {}
